export default __webpack_public_path__ + "static/media/oq_fazemos.de12432e.jpg";